export const MAPBOX_BASEMAP_STYLE =
    'mapbox://styles/insecurityinsight/cmmc827qu001c01scewqk78y0'; // Style of MapBox basemap. For options see here: https://www.mapbox.com/maps/

export const LAYER_NAMES = {
    POINTS: 'points',
    COUNTRIES: 'countries',
    COUNTRIES_HOVER: 'countriesHover',
    COUNTRIES_HOVER_OUTLINE: 'countriesHoverOutline',
};

export const LAYER_SOURCE_NAMES = {
    POINTS: 'points',
    COUNTRIES: 'countries',
};

export const DATA_VALUES = {
    HEALTH: 'Health',
    CONFLICT: 'conflictViolence',
    POLITICAL: 'politicalRelatedViolence',
    VACCINATION: 'vaccinationRelatedViolence',
    OUTBREAK: 'outbreakRelatedViolence',
    EBOLA: 'ebolaRelatedViolence',
    MATERNAL_CARE: 'maternalCareRelatedViolence',
    DRONE_IMPACT: 'droneRelatedViolence',
};

export const INCIDENTS_ICON = {
    COLOUR: 'hsl(51, 100%, 55%)',
    BORDER_COLOUR: 'Grey',
    OPACITY: 0.75,
    STROKE_WIDTH: 1,
    STROKE_OPACITY: 0.5,
    HOVER_COLOUR: 'hsl(51, 100%, 65%)',
    HOVER_BORDER_COLOUR: 'White',
    HOVER_OPACITY: 1,
    HOVER_STROKE_WIDTH: 2,
};

export const STEP_STYLE = ['step', ['get', 'incidentsCount']];
